import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { FeedRating } from '@app/model/feedsRating';
import { Product } from '@app/model/product';
import { PaymentService } from '@app/services/Payment/payment.service';
import { ProductService } from '@app/services/Product/product.service';
import { FeedsService } from '@app/services/feeds/feeds.service';
import { LoaderService } from '@app/services/loader/loader.service';
import { environment } from '../../../../environments/environment.prod';
import Swiper from 'swiper';
import { SeoService } from '@app/services/seo/seo.service';

@Component({
  selector: 'app-product-details',
  templateUrl: './product-details.component.html',
  styleUrls: ['./product-details.component.css']
})
export class ProductDetailsComponent implements OnInit {
  active = 1;
  qty =1;
  product: any;
  sellProductInfoId: any;
  userInfoId: any;
  
  feedList:any;
  feedTotal:any;
  feedAvg:any;

  serverImgUrl= environment.IMG_URL;
  
  hideshow: boolean = false;
  toggle() {
    this.hideshow = !this.hideshow;
  }

  constructor(
    private router: Router,
    private productService: ProductService,
    private paymentService: PaymentService,
    private route: ActivatedRoute, 
    private loader: LoaderService,
    private feedsService: FeedsService,
    private seoService: SeoService
  ) {
    this.product = new Product();
  }

  ngOnInit() {
    this.route.params.subscribe(params => {
      this.sellProductInfoId = params['id'];
      const routeValue = params['uid'];
      if (this.isUuid(routeValue)) {
        this.loadProductByOwner(routeValue);
      } else if (routeValue && this.sellProductInfoId) {
        this.resolveProductSlug(routeValue);
      }
    });
    
    var swiper = new Swiper(".mySwiper", {
      zoom: true,
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
      pagination: {
        el: ".swiper-pagination",
        clickable: true,
      },
    });
  }

  private loadProductByOwner(userInfoId: string): void {
    this.userInfoId = userInfoId;
    this.getProductDetailsById();
    this.fetchFeedsByProduct();
  }

  private resolveProductSlug(slug: string): void {
    this.productService.resolveProductOwnerBySlug(decodeURIComponent(slug), this.sellProductInfoId)
      .subscribe({
        next: (product: any) => {
          if (product?.userInfoId) {
            this.loadProductByOwner(product.userInfoId);
          }
        }
      });
  }

  private isUuid(value: string): boolean {
    return /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i.test(value);
  }

  getProductDetailsById(): void {
    this.loader.show();
    this.productService.getSellerProductByUUID_Id(this.sellProductInfoId, this.userInfoId)
      .subscribe({
        next: (res:any) => {
          this.product = res as Product;  
          if (res.success !== 0) {
            this.product.sellProductInfoId = this.product.data[0].sellProductInfoId;
            this.product.sellProductTitle = this.product.data[0].sellProductTitle;
            this.product.sellProductPrice = this.product.data[0].sellProductPrice;
            this.product.sellProductDiscount = this.product.data[0].sellProductDiscount;
            this.product.sellProductQty = this.product.data[0].sellProductQty;
            this.product.sellProductDetails = this.product.data[0].sellProductDetails;
            this.product.sellProductImageURL = this.product.data[0].sellProductImageURL;
            this.product.sellProductAdditionalInfo = this.product.data[0].sellProductAdditionalInfo;
            this.product.sellProductStartDate = this.product.data[0].sellProductStartDate;
            this.product.sellProductEndDate = this.product.data[0].sellProductEndDate;
            this.product.status = this.product.data[0].status;
            const description = this.product.sellProductDetails || `Buy ${this.product.sellProductTitle} from a Maharashtra business.`;
            this.seoService.update({
              title: `${this.product.sellProductTitle} | Product Details`,
              description: `${this.product.sellProductTitle} - ${description}`.substring(0, 160),
              keywords: `${this.product.sellProductTitle}, Maharashtra product, ${this.product.sellProductDetails || ''}`.substring(0, 255),
              image: this.product.sellProductImageURL
                ? `${this.serverImgUrl}sellProducts/${this.product.sellProductImageURL}`
                : undefined,
              type: 'product'
            });
            window.scroll(0, 0);
          } else {
            this.product.sellProductInfoId = '1';
            this.product.sellProductTitle = 'No Product';
            this.product.sellProductPrice = '';
            this.product.sellProductDiscount = '';
            this.product.sellProductQty = '';
            this.product.sellProductDetails = '';
            this.product.sellProductImageURL = '';
            this.product.sellProductAdditionalInfo = '';
            this.product.sellProductStartDate = '';
            this.product.sellProductEndDate = '';
            this.product.status = '';
          }
        },
        // error: (e) => {
        //   console.error('Error loading product details.', e);
        // },
        // complete: () => {
        //   setTimeout(() => {
        //     this.loader.hide();

        //   }, 2000);
        //   console.log('Loaded product details from the API.');
        // }
      });
  }
  
  fetchFeedsByProduct(): void {
    this.feedsService.fetchFeedsByProduct(this.userInfoId, this.sellProductInfoId)
      .subscribe({
        next: (p) => {
          this.feedList = p as FeedRating;
          this.feedTotal = this.feedList.data.length;
          var sum = 0;
          if (this.feedList.data != null && this.feedList.data.length > 0) {
            for (var i = 0; i < this.feedList.data.length; i++) {
              sum += this.feedList.data[i].feedRating;
            }
            this.feedAvg = sum / this.feedList.data.length;
          }
          else {
            this.feedAvg = 0; 
          }
        }
      });
  }

  addToCart(product: Product) {
    // Implement your cart logic here
    console.log('Product added to cart:', product);
    //localStorage.setItem('cart', JSON.stringify(product));
    this.paymentService.addToCart(product);
    debugger
  }

  buyNow(product: Product) {
    debugger
    // Implement your checkout logic here
    this.paymentService.createOrder(product).subscribe((response: any) => {
      if (response.status == 200) {
        debugger
        const paymentOrderId = response.data.id;
        this.paymentService.setSelectedProductForCheckout(product)
        this.router.navigateByUrl(`/checkout/${paymentOrderId}`);
      } else {
        alert('server side error cant process order');
      }
    });
  }
}
